// utils/fetchDocumentTypes.js
import { getAuthHeaders } from './apiUtils';

export const fetchDocumentTypes = async (
  setDocumentTypes, 
  setSelectedDocumentType = () => {}, 
  setSelectedDocumentTypeId = () => {}, 
  setSelectedCategoryId = () => {}, 
  setEta = () => {}, 
  Id = null,
  userSettings = null
) => {
    try {
        // This response is authorization-scoped. Always fetch it with the
        // current user's token; a shared browser cache could expose a previous
        // account's company allowlist after sign-out/sign-in.
        const headers = await getAuthHeaders();
        const response = await fetch('/api/v3/configuration/document-types', {
            credentials: 'include',
            headers: {
                ...headers,
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (Array.isArray(data)) {
            // Apply user settings filter
            const filteredTypes = filterTypesByUserSettings(data, userSettings);
            setDocumentTypes(filteredTypes);
            
            if (Id !== null && Id < filteredTypes.length) {
                const selectedType = filteredTypes[Id];
                if (selectedType) {
                    setSelectedDocumentType(selectedType.name || '');
                    setSelectedDocumentTypeId(selectedType.id || '');
                    setSelectedCategoryId(selectedType.category || '');
                    setEta(selectedType.eta || 0);
                }
            }
        } else {
            throw new Error('Document types response was not an array');
        }
    } catch (error) {
        // Only log detailed errors in development
        if (process.env.NODE_ENV === 'development') {
            console.error('Error fetching document types:', error);
        }
        // Fail closed. Retaining a prior account's or prior company policy's
        // list would make a disabled type selectable during an outage.
        setDocumentTypes([]);
    }
};

// Helper function to filter document types based on user settings
const filterTypesByUserSettings = (types, userSettings) => {
    const hiddenIds = new Set(
        Array.isArray(userSettings?.hiddenDocumentTypeIds)
            ? userSettings.hiddenDocumentTypeIds
            : []
    );

    // The server enforces company, role and beta opt-in. This filter only
    // applies personal menu visibility; an empty result stays empty.
    const filtered = types.filter(type => !hiddenIds.has(type.id));

    // Sort alphabetically by name (case-insensitive). Per Ben's 2026-04-18 request.
    return [...filtered].sort((a, b) =>
        (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' })
    );
};
